(() => {
  const selector = 'img[data-gf-gallery-image]';
  const load = image => {
    if (!image?.hasAttribute('data-gf-gallery-image')) return;
    image.loading = 'eager';
    image.fetchPriority = 'high';
    image.srcset = image.dataset.gfGallerySrcset;
    image.src = image.dataset.gfGallerySrc;
    image.removeAttribute('data-gf-gallery-image');
    image.removeAttribute('data-gf-gallery-srcset');
    image.removeAttribute('data-gf-gallery-src');
  };
  const loadItem = item => item?.querySelectorAll(selector).forEach(load);
  const initialize = () => {
    document.querySelectorAll('media-gallery').forEach(gallery => {
      if (gallery.dataset.gfLoadingReady) return;
      gallery.dataset.gfLoadingReady = 'true';
      const viewer = gallery.querySelector('[id^="GalleryViewer"]');
      const viewport = gallery.querySelector('[id^="Slider-Gallery"]');
      if (!viewport) return;
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            load(entry.target);
            observer.unobserve(entry.target);
          });
        }, { root: viewport, threshold: 0.01 });
        gallery.querySelectorAll(selector).forEach(image => observer.observe(image));
      } else {
        gallery.querySelectorAll(selector).forEach(load);
      }
      viewer?.addEventListener('slideChanged', event => loadItem(event.detail.currentElement));
      viewer?.addEventListener('pointerdown', () => {
        const items = [...viewport.children];
        const left = viewport.getBoundingClientRect().left;
        let current = 0, distance = Infinity;
        items.forEach((item, index) => {
          const nextDistance = Math.abs(item.getBoundingClientRect().left - left);
          if (nextDistance < distance) { current = index; distance = nextDistance; }
        });
        loadItem(items[current - 1]);
        loadItem(items[current + 1]);
      }, { passive: true });
    });
  };
  const intent = event => {
    const target = event.target.closest('[data-target]');
    const gallery = target?.closest('media-gallery');
    if (!gallery) return;
    loadItem(gallery.querySelector('[data-media-id="' + CSS.escape(target.dataset.target) + '"]'));
  };
  ['pointerover', 'focusin', 'click'].forEach(name => document.addEventListener(name, intent, true));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
